module.exports = __webpack_public_path__ + "img/linkedin.ef56b8c.png";